import moment from "moment";

const filterDataFilled = (data = []) =>
  data.filter((item) => {
    const targets = [
      item?.unitEntryTargetQty,
      item?.unitServiceTargetNonKPBQty,
      item?.unitServiceTargetKPBQty,
      item?.partTargetNonOilNonSparkPlugQty,
      item?.oilTargetNonKPB,
    ];

    return targets.some((v) => Number(v) > 0);
  });

const firstDayOfMonth = (input) => {
  return moment(input, "DD-MM-YYYY").startOf("month").format("DD-MM-YYYY");
};

const filterValidDetails = (details = []) => {
  return details?.map((item) => ({
    mechanicManagementDetailId: item?.mechanicManagementDetailId ?? null,
    mechanicManagementId: item?.mechanicManagementId ?? null,
    mechanicId: item?.mechanicId ?? null,
    unitEntryTargetQty: item?.unitEntryTargetQty ?? null,
    unitServiceTargetNonKPBQty: item?.unitServiceTargetNonKPBQty ?? null,
    unitServiceTargetKPBQty: item?.unitServiceTargetKPBQty ?? null,
    partTargetNonOilNonSparkPlugQty:
      item?.partTargetNonOilNonSparkPlugQty ?? null,
    oilTargetNonKPB: item?.oilTargetNonKPB ?? null,
  }));
};

const constructPayload = (data, selectedCabang) => {
  return {
    mechanicManagementId: data?.mechanicManagementId ?? null,
    mechanicManagement: data?.mechanicManagement ?? null,
    effectiveDate: data?.effectiveDate
      ? firstDayOfMonth(data.effectiveDate?.format("DD-MM-YYYY"))
      : null,
    kodeCabang: selectedCabang?.value ?? null,
    detail: filterValidDetails(data?.dataTable),
  };
};

const validateForm = (data = {}) => {
  const errors = {};

  errors.effectiveDate = data?.effectiveDate ? null : "Field Wajib Diisi";

  const unsavedItem = data?.dataTable?.find((item) => !item?.isSaved);
  
  if (unsavedItem) {
    errors.dataTable =
      "Terdapat data mekanik yang belum disimpan. Silakan simpan atau hapus data terlebih dahulu.";
  } else {
    errors.dataTable = null;
  }

  const isValid = Object.values(errors).every((v) => v === null);
  return { errors, isValid };
};

export default { constructPayload, validateForm, firstDayOfMonth };
